import { Button, Theme, withStyles } from '@material-ui/core'
import i18next from 'i18next'
import { ComponentType } from 'react'
import { MuiClasses } from '../../types'

const styles = ({ spacing }: Theme) => ({
  button: {
    marginTop: spacing(),
    fontWeight: 400
  }
})

interface SubmitFormButtonProps {
  submitting: boolean
  label?: string
  classes: MuiClasses
  customClasses?: any
  disabled?: boolean
  icon?: ComponentType
  variant?: 'outlined' | 'contained'
  textColor?: string
  backgroundColor?: string
  borderRadius?: string
  fullWidth?: boolean
}

/** default label is 'general.submit' */
const SubmitFormButton = ({
  submitting,
  label,
  classes,
  customClasses,
  disabled,
  variant = 'outlined',
  icon: Icon,
  textColor,
  backgroundColor,
  fullWidth = false,
  borderRadius
}: SubmitFormButtonProps) => {
  return (
    <Button
      className={customClasses ? customClasses : classes.button}
      type='submit'
      variant={variant}
      color='primary'
      fullWidth={fullWidth}
      disabled={submitting || disabled}
      style={{
        whiteSpace: 'nowrap',
        color: textColor ? textColor : '#000',
        borderRadius: borderRadius ? borderRadius : '10px',
        backgroundColor: backgroundColor ? backgroundColor : ''
      }}
    >
      {Icon && <Icon />}
      {i18next.t(
        label ? label : disabled ? 'general.confirmed' : 'general.confirm'
      )}
    </Button>
  )
}

export default withStyles(styles)(SubmitFormButton)
